import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2OrderModule } from 'ng2-order-pipe';

import { HttpLinkModule, HttpLink } from 'apollo-angular-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { Apollo, ApolloModule } from 'apollo-angular';
import { ApolloLink } from 'apollo-link';
import { onError } from 'apollo-link-error';

// Components
import { AppComponent } from './app.component';
import { HeaderComponent } from './includes/header/header.component';
import { IncludesComponent } from './includes/includes.component';
import { HomeComponent } from './home/home.component';
import { HomeUserComponent } from './home/home.user.component';
import { CriteriaAddComponent } from './criteria/criteria.add.component';
import { VisionsStripTemplateComponent } from './vision/visions.strip.template';
import { CriteriaFormComponent } from './criteria/criteria.form.component';
import { VisionCriteriasComponent } from './vision/vision.criterias.component';
import { CriteriaShortDetailsComponent } from './criteria/criteria.short.details.component';
import { Routes } from './routes';
import { JobsEmptyComponent } from './jobs/jobs-empty.component';
import { JobsAddedComponent } from './jobs/jobs-added.component';
import { JobsCreateComponent } from './jobs/jobs-create.component';
import { JobsEditComponent } from './jobs/jobs-edit.component';
import { CriteriaJobsTemplate } from './jobs/criteria-jobs.template';
import { VisionCriteriasEditComponent } from './vision/vision.criterias-edit.component';
import { CriteriaEditComponent } from './criteria/criteria.edit.component';
import { JobsVisionsComponent } from './jobs/jobs-visions.component';

// Services
import { AuthService } from './services/auth/auth.service';
import { LoginRedirectGuard } from './services/auth/login-redirect.guard';
import { VisionService } from './services/vision.service';
import { CriteriaService } from './services/criteria.service';
import { UserService } from './services/user.service';
import { AuthGuard } from './services/auth/auth.guard';
import { ProfileDataRecieveService } from './services/user_data_recieve.service';
import { VisionModel } from './models/vision.model';
import { CriteriaModel } from './models/criteria.model';
import { JobService } from './services/job.service';
import { OffersModel } from './models/offers.model';
import { OffersResult } from './models/offer-result-details';
import { SpinnerComponent, SpinnerService } from './services/spinner';

// Models
import { SurveyTypes } from './models/surveytypes';
import { environment, logError } from '../environments/environment';
import { HttpClientModule, HttpHeaders } from '@angular/common/http';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent, IncludesComponent, HeaderComponent, SpinnerComponent, HomeUserComponent,
    VisionCriteriasComponent, CriteriaAddComponent, CriteriaFormComponent, VisionsStripTemplateComponent,
    CriteriaShortDetailsComponent, JobsEmptyComponent, JobsAddedComponent, JobsCreateComponent, CriteriaJobsTemplate,
    VisionCriteriasEditComponent, CriteriaEditComponent, JobsVisionsComponent, JobsEditComponent
  ],
  imports: [
    BrowserModule, Ng2OrderModule,
    NgbModule.forRoot(),
    Routes,
    HttpLinkModule,
    HttpClientModule,
    ApolloModule,
    FormsModule, ReactiveFormsModule,
  ],
  providers: [AuthService, AuthGuard, LoginRedirectGuard, VisionService, CriteriaService,
    UserService, SurveyTypes, SpinnerService, ProfileDataRecieveService, VisionModel,
    JobService, CriteriaModel, OffersModel, OffersResult],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
    apollo: Apollo,
    httpLink: HttpLink
  ) {
    // Setup authorization for Apollo Client
    const authLink = new ApolloLink((operation, forward) => {
      // Get the Graphcool token from local storage before each call if it exists
      const token = AuthService.getGraphCoolAuthHeader();
      // Add the authorization to the headers
      operation.setContext({
        headers: new HttpHeaders().set('Authorization', token ? `Bearer ${token}` : '')
      });
      return forward(operation);
    });

    // Setup error handling for Apollo Client
    const errorLink = onError((error) => {
      logError(error);
    });

    // Create Apollo Client
    apollo.create({
      link: ApolloLink.from([authLink, errorLink, httpLink.create({ uri: environment.graphCoolConfig.simpleApiEndPoint })]),
      cache: new InMemoryCache(),
      defaultOptions: {
        watchQuery: {
          errorPolicy: 'all'
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/app.module.ts